import AddIcon from "@mui/icons-material/Add";
import { Fab, Grid, Menu, MenuItem, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Postrequestcall } from "../../request/Postrequest";
import Loader from "../../common/Loader";
import { FETCH_CLIENT_SITE_FILING_LIST } from "../../constant/Apipath";
import ClientSiteFilingAddModel from "./clientSiteFilingAddModal/ClientSiteFilingAddModel";
import ClientSitefilingListing from "./component/ClientSitefilingListing";
import SiteFilePreview from "./component/previewModel/SiteFilePreview";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";

export default function ClientSiteFilingFolder() {
  const { siteid: id, folderId } = useParams();
  const data = useLocation();
  const navigate = useNavigate();
  const JobData = data?.state;

  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const CLIENT_ACCENT_COLOR = selectedClientData?.AccentColor;

  const [anchorEl, setAnchorEl] = useState(null);
  const [addModal, setAddModal] = useState(false);
  const [sortMenu, setSortMenu] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [sortbyValue, setSortbyValue] = useState("Date");
  const [siteFilingData, setSiteFilingData] = useState([]);
  const [totoalItemCount, setTotalItemCount] = useState("");
  const [showFilePreview, setShowFilePreview] = useState(false);
  const [showFilePreviewFile, setShowFilePreviewFile] = useState([]);
  const location = useLocation();

  const LANGUAGE = ClientEnglishFallback?.ClientSiteFilingFolder(
    multiLanguageData?.ClientSiteFilingFolder || {}
  );
  const { TEXT_TYPE, TEXT_NAME, TEXT_UPLOAD_DATE, TEXT_ITEMS, TEXT_SORT } = LANGUAGE;

  let SiteFileArray = [
    { name: "Type", value: TEXT_TYPE },
    { name: "Name", value: TEXT_NAME },
    { name: "Date", value: TEXT_UPLOAD_DATE }
  ];

  const [sortbyTransValue, setSortbyTransValue] = useState(TEXT_UPLOAD_DATE);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setSortMenu(() => true);
  };

  const handleClose = (value) => {
    setAnchorEl(null);
    setSortMenu(false);
    if (value) {
      setSortbyValue(value);
    }
    if (value)
      switch (value) {
        case "Type":
          setSortbyTransValue(TEXT_TYPE);
          break;
        case "Name":
          setSortbyTransValue(TEXT_NAME);
          break;
        case "Date":
          setSortbyTransValue(TEXT_UPLOAD_DATE);
          break;
        default:
          break;
      }
  };

  useEffect(() => {
    if (!folderId) fetchSiteFilingData();
  }, [selectedClientData, id, folderId, sortbyValue, location?.state?.searchText]);

  const fetchSiteFilingData = async () => {
    setLoading(true);
    try {
      let obj = {
        ClientId: selectedClientData?.ClientId,
        ClientJobId: Number(id),
        SortBy: sortbyValue,
        PageNumber: 1,
        NrRowsPerPage: 100,
        SearchString: location?.state?.searchText || ""
      };
      let res = await Postrequestcall(FETCH_CLIENT_SITE_FILING_LIST, obj, loginData?.accessToken);
      if (res?.status === 200) {
        const data = res?.data;
        setSiteFilingData(data?.data);
        setTotalItemCount(data?.nrOfRecords);
      }
    } catch (error) {
      console.error("fetchSiteFilingData-> Error fetching Site Filling list: ", error);
    } finally {
      setLoading(false);
    }
  };

  const handelNavigate = (item) => {
    if (item?.fileType == "") {
      setSiteFilingData([]);
      navigate(`${item?.folderId}`, { state: { ...item, ...JobData } });
    }
  };

  const handleCloseFilePreview = () => {
    setShowFilePreview(false);
    setShowFilePreviewFile([]);
  };

  const SortMenu = () => (
    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={sortMenu}
      onClose={() => handleClose("")}
      MenuListProps={{
        "aria-labelledby": "basic-button"
      }}>
      {SiteFileArray.map((menu, index) => {
        return (
          <MenuItem
            key={index}
            sx={{
              color: sortbyValue === menu.name ? selectedClientData?.AccentColor : ""
            }}
            onClick={() => handleClose(menu.name)}>
            {menu.value}
          </MenuItem>
        );
      })}
    </Menu>
  );

  return (
    <>
      {isLoading ? (
        <Loader fullScreen />
      ) : (
        <div>
          <Grid container size={12} rowGap={2} spacing={2}>
            <Grid size={12}>
              <Typography>
                {JobData?.jobCode}
                {" - "} {JobData?.jobName}
              </Typography>
              <Stack display={"flex"} flexDirection={"row"} justifyContent={"space-between"}>
                <Typography
                  sx={{
                    fontSize: "15px",
                    color: "grey"
                  }}>
                  {totoalItemCount} {TEXT_ITEMS}
                </Typography>
                <Stack display={"flex"} flexDirection={"row"} gap={1}>
                  <Typography
                    sx={{
                      fontSize: "15px",
                      color: "grey"
                    }}>
                    {TEXT_SORT}
                  </Typography>
                  <Typography
                    onClick={handleClick}
                    sx={{
                      cursor: "pointer",
                      fontSize: "15px",
                      color: selectedClientData?.AccentColor
                    }}>
                    {sortbyTransValue}
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
            {siteFilingData?.map((item, i) => (
              <Grid
                onClick={() => {
                  handelNavigate(item);
                }}
                sx={{
                  border: "1px solid transparent",
                  cursor: "pointer",
                  padding: "10px",
                  "&:hover": {
                    border: "1px solid #e4e4e4",
                    borderRadius: "10px",
                    boxShadow: "0px 0px 10px 0px #e4e4e4",
                    transition: "0.3s"
                  }
                }}
                size={{
                  xs: 4,
                  sm: 4,
                  md: 2,
                  lg: 2,
                  xl: 1.5
                }}
                key={i}>
                <ClientSitefilingListing
                  item={item}
                  setShowFilePreviewFile={setShowFilePreviewFile}
                  setShowFilePreview={setShowFilePreview}
                  textItems={TEXT_ITEMS}
                />
              </Grid>
            ))}
          </Grid>
        </div>
      )}
      <SortMenu />

      <Fab
        onClick={() => {
          setAddModal(true);
        }}
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px"
        }}
        sx={{
          bgcolor: CLIENT_ACCENT_COLOR,
          "&:hover": {
            bgcolor: CLIENT_ACCENT_COLOR
          }
        }}
        aria-label="add">
        <AddIcon
          style={{
            color: "white"
          }}
        />
      </Fab>
      {showFilePreview && (
        <SiteFilePreview
          open={showFilePreview}
          handleClose={handleCloseFilePreview}
          file={showFilePreviewFile}
        />
      )}
      <ClientSiteFilingAddModel
        reloadData={() => {
          fetchSiteFilingData();
        }}
        folderData={JobData}
        isOpen={addModal}
        onClose={() => setAddModal(false)}
      />
    </>
  );
}
